/**
 * Styled Components - Created by david on 26/02/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex: 1;
  height: 60vh;
  justify-content: center;
  align-items: center;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/WithLoading/styledComponents.tsx